import axios from 'axios';
import i18n from '@/i18n';

export default {
  baseURL: process.env.BASE_URL + "api/action",

  getSurveyInstanceData(surveyInstanceId, cancelToken, localizationId) {
    return axios
      .get(`survey-instance/${surveyInstanceId}`, {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  getSurveyInstances(cancelToken, localizationId) {
    return axios
      .get(`survey-instances`, {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  /* 
   * SurveyRevision
   */
  SurveyRevisionStatus: {
    New: 0,
    Approved: 5,
    Dismissed: 10,
    DismissedCustom1: 11,
    DismissedCustom2: 12,
    DismissedCustom3: 13,
    InProgress: 20,
    InProgressAgency: 21,
    InProgressCustom1: 22,
    Recheck: 23,
    InProgressCustom2: 24,
    Solved: 25,
    Revised: 30,
    RevisedApprovedGoodwill: 31,
    RevisedApprovedCustom1: 32,
    RevisedApprovedCustom2: 33,
    RevisedApprovedCustom3: 34,
    RevisedApproved: 35,
    RevisedDismissed: 36,
    RevisedDismissedCustom1: 37,
    RevisedDismissedCustom2: 38,
    RevisedDismissedCustom3: 39,
    Done: 40
  },

  getSurveyRevisions(filter, options, cancelToken) {
    return axios.post('survey-revisions',
      { 
        'client-ids': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
        'project-ids': (filter && _.size(filter.projectIds) > 0) ? filter.projectIds.join() : null,
        'survey-ids': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
        'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
        'scenario-ids': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
        'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
        'property-ids-use-logical-and': options ? options.propertyUseLogicalAnd : null,
        'client-location-ids': (filter && _.size(filter.locationIds) > 0) ? filter.locationIds.join() : null,
        'search-text': (filter && filter.searchText) ? filter.searchText : null,
        'column-filter': (filter && _.size(filter.columnFilter) > 0) ? JSON.stringify(filter.columnFilter) : null,
        'sort-by': (filter && filter.sortBy) ? filter.sortBy : null,
        'sort-descending': (filter && filter.sortDescending) ? filter.sortDescending : null,
        'localization-id': (options && options.localizationId) ? options.localizationId : i18n.locale,
        'page-size': options ? options.pageSize : null,
        'page': options ? options.page : null,
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  getSurveyRevision(surveyRevisionId, cancelToken) {
    return axios
      .get(`survey-revision/${surveyRevisionId}`, {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  setSurveyRevision(surveyRevision) {
    return axios
      .put("survey-revision", surveyRevision,
        {
          baseURL: this.baseURL,
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [
            (data) =>
              // Don't serialize internal properties
              JSON.stringify(data, (key, value) => key.startsWith('_') ? undefined : value)
          ],
        });
  },

  createOrUpdateSurveyRevisionComment(surveyRevisionId, surveyRevisionComment) {
    return axios
      .put(`survey-revision/${surveyRevisionId}/comment`, surveyRevisionComment,
        {
          baseURL: this.baseURL,
        });
  },

  /* 
   * SurveyImprovement
   */
  SurveyImprovementStatus: {
    New: 0,
    Revised: 30,
  },

  getSurveyImprovements(filter, options, cancelToken) {
    return axios.post('survey-improvements',
    { 
      'client-ids': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
      'project-ids': (filter && _.size(filter.projectIds) > 0) ? filter.projectIds.join() : null,
      'survey-ids': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
      'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
      'scenario-ids': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
      'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
      'property-ids-use-logical-and': options ? options.propertyUseLogicalAnd : null,
      'client-location-ids': (filter && _.size(filter.locationIds) > 0) ? filter.locationIds.join() : null,
      'search-text': (filter && filter.searchText) ? filter.searchText : null,
      'column-filter': (filter && _.size(filter.columnFilter) > 0) ? JSON.stringify(filter.columnFilter) : null,
      'sort-by': (filter && filter.sortBy) ? filter.sortBy : null,
      'sort-descending': (filter && filter.sortDescending) ? filter.sortDescending : null,
      'localization-id': (options && options.localizationId) ? options.localizationId : i18n.locale,
      'page-size': options ? options.pageSize : null,
      'page': options ? options.page : null,
    },
    {
      baseURL: this.baseURL,
      cancelToken: cancelToken ? cancelToken.token : null
    });
  },

  getSurveyImprovement(surveyImprovementId, cancelToken) {
    return axios
      .get(`survey-improvement/${surveyImprovementId}`, {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  setSurveyImprovement(surveyImprovement) {
    return axios
      .put("survey-improvement", surveyImprovement,
        {
          baseURL: this.baseURL,
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [
            (data) =>
              // Don't serialize internal properties
              JSON.stringify(data, (key, value) => key.startsWith('_') ? undefined : value)
          ],
        });
  },

  createOrUpdateSurveyImprovementComment(surveyImprovementId, surveyImprovementComment) {
    return axios
      .put(`survey-improvement/${surveyImprovementId}/comment`, surveyImprovementComment,
        {
          baseURL: this.baseURL,
        });
  }
};
